module.exports = __webpack_public_path__ + "static/media/subbaru.a1e70bb8.png";